import { useTranslation } from "react-i18next";

import { Spinner } from "@krea/shared/design-system/Spinner";

export const AutoStartAuthFlow = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col">
      <Spinner />
      <p className="mt-2 text-center font-semibold">
        {t("bankID.SE.autostartDescription")}
      </p>
    </div>
  );
};
